import { render } from "./GoalsListV2.vue?vue&type=template&id=79317b14&scoped=true"
import script from "./GoalsListV2.vue?vue&type=script&lang=js"
export * from "./GoalsListV2.vue?vue&type=script&lang=js"

import "./GoalsListV2.vue?vue&type=style&index=0&id=79317b14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79317b14"]])

export default __exports__